import {AxiosRequestConfig} from 'axios'
import axiosConfig from '../../../api/axiosConfig'
import {NewPasswordPayload, ResetPasswordPayload} from './models'

function login(payload: any, config?: AxiosRequestConfig | undefined) {
  return axiosConfig.post(`/login`, payload, config)
}

// BEGIN: Forgot / Reset password
/**
 * Step 1: request an email containing the reset password link.
 * POST /auth/reset-password
 * Always resolves with 200 regardless of whether the email exists (anti user
 * enumeration), rate limited to 5 requests / 60 minutes per IP by the API.
 */
function resetPassword(payload: ResetPasswordPayload, config?: AxiosRequestConfig | undefined) {
  return axiosConfig.post(`/auth/reset-password`, payload, config)
}

/**
 * Step 2a: check whether the token from the link is still valid.
 * GET /verify-token?confirmation_token=<token>&type=reset-password
 * Not rate limited by the API.
 */
function verifyToken(token: string, config?: AxiosRequestConfig | undefined) {
  return axiosConfig.get(`/verify-token`, {
    ...config,
    params: {
      ...config?.params,
      confirmation_token: token,
      type: 'reset-password',
    },
  })
}

/**
 * Step 2b: submit the new password along with the token.
 * POST /auth/new-password
 * `token` is sent in the body only (no query string), rate limited to
 * 5 requests / 60 minutes per IP by the API.
 */
function newPassword(payload: NewPasswordPayload, config?: AxiosRequestConfig | undefined) {
  return axiosConfig.post(`/auth/new-password`, payload, config)
}

/**
 * Same as `newPassword`, dedicated to trade show accounts: automatically signs
 * the user in right after the password has been reset.
 *
 * NOTE: `gori-partner-api` has no concept of trade show accounts and does not
 * implement this endpoint (`verify-token` never returns `trade_show_account`),
 * so this call is currently unreachable in practice. Kept for parity with the
 * ShipBae flow in case the Partner domain adds this concept later.
 */
function tradeShowNewPassword(
  payload: NewPasswordPayload,
  config?: AxiosRequestConfig | undefined
) {
  return axiosConfig.post(`/auth/tradeshow-new-password`, payload, config)
}
// END: Forgot / Reset password

export const AuthService = {
  login,
  resetPassword,
  verifyToken,
  newPassword,
  tradeShowNewPassword,
}
